// extracted by mini-css-extract-plugin
export default {"loading":"style_loading__BIGpZ"};